import type { ReactNode } from 'react';
import { REVIEW_STEP } from '../logic';

export const opts = (o: Record<string, string>) => Object.entries(o).map(([value, label]) => ({ value, label }));

export function StepHeader({ step, title, children }: { step: number; title: string; children: ReactNode }) {
  return (
    <div className="flex flex-col gap-2">
      <span className="eyebrow">Step {step} of {REVIEW_STEP}</span>
      <h1 className="m-0 text-[26px] font-bold leading-[1.2] tracking-[-0.02em] sm:text-[30px]" tabIndex={-1} data-step-heading style={{ outline: "none" }}>{title}</h1>
      <p className="m-0 max-w-[680px] text-base leading-[1.55] text-ink-2">{children}</p>
    </div>
  );
}

/** White card that groups a step's fields. */
export function FormCard({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={`flex min-w-0 flex-col gap-6 rounded-card border border-line bg-white p-5 sm:p-6 ${className ?? ''}`}>{children}</div>;
}

/** Group label above a run of cards ("CLIENTS AND WORK"). */
export function GroupLabel({ children }: { children: ReactNode }) {
  return <h2 className="section-label m-0 mt-1">{children}</h2>;
}

/** Issue paths → messages, for inline errors after a submit attempt. */
export type ErrorMap = Record<string, string>;
